import AskMeAnythingLauncher from './AskMeAnythingLauncher';
import Launcher from './Launcher';
import { jsx as _jsx } from "react/jsx-runtime";
const LauncherContainer = props => {
  if (props.showAskMeAnythingLauncher) return /*#__PURE__*/_jsx(AskMeAnythingLauncher, Object.assign({}, props));
  return /*#__PURE__*/_jsx(Launcher, Object.assign({}, props));
};
LauncherContainer.displayName = 'LauncherContainer';
export default LauncherContainer;